import { render, staticRenderFns } from "./AddDish.vue?vue&type=template&id=eab9fdec&scoped=true&"
import script from "./AddDish.vue?vue&type=script&lang=js&"
export * from "./AddDish.vue?vue&type=script&lang=js&"
import style0 from "./AddDish.vue?vue&type=style&index=0&id=eab9fdec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab9fdec",
  null
  
)

export default component.exports